var cell_default = {
  "cell": "AEckt",
  "header": "k1OqK",
  "selected": "_8kEfd",
  "editing": "_7xkNZ",
  "singleSelection": "Y6od0",
  "hideLastBlock": "Fkryu",
  "editorWrapper": "KMip1",
  "viewerWrapper": "T8rHa",
  "hideFirstBlock": "_4KQyZ",
  "editor": "_4BPzi",
  "edit": "skXmi",
  "view": "x3WFE",
  "editingToolbarWrapper": "hpaWA",
  "selectAll": "hsckR",
  "disableSelection": "bgUA7"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
